import React from 'react';
import { Price, Typography } from 'fronton-react';
import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { getTextColor } from './helpers';
import { PriceBlock } from '../../../styles';

type TProps = {
  isDisable: boolean;
  counter: number;
  product: TComplimentaryProductInfo;
};

export const ComplimentaryBlockPrice = ({ isDisable, counter, product }: TProps) => {
  const getTotalPrice = () => product?.salesPriceValueInConsumerUnitValue * counter;
  const textColor = getTextColor(isDisable);
  return (
    <PriceBlock>
      <Price
        color={textColor}
        align="center"
        size="l"
        units={counter > 1 ? '₽' : `₽ / шт.`}
        value={getTotalPrice()}
        variant="medium"
      />
      {counter > 1 ? (
        <Typography size="caption" variant="minor" color={textColor}>
          {`${product?.salesPriceValueInConsumerUnitValue} ₽ \\шт.`}
        </Typography>
      ) : null}
    </PriceBlock>
  );
};
